import { logUsage } from 'owa-analytics';

export function logRibbonResponseToAria(
    sessionId: string,
    feature: string,
    subFeature: string,
    buttonClicked: string
) {
    logUsage(
        'FeedbackRibbon',
        {
            sessionId: sessionId,
            feature: feature,
            subFeature: subFeature,
            buttonClicked: buttonClicked,
        },
        {
            isCore: true,
        }
    );
}
